import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';
import Button from '../../shared/Button';
import IsnIntegration from '../../shared/IsnIntegration';
import LabeledInput from '../../shared/LabeledTextInput';
import { ISN_RESPONSE_STATUS } from '../../../constants/isnResponse';
import styles from './styles.scss';

class IsnIntegrationParams extends React.Component {
  constructor(props) {
    super(props);
  }

  static get propTypes() {
    return {
      isnKey: PropTypes.string,
      isnDomain: PropTypes.string,
      accessKey: PropTypes.string,
      secretKey: PropTypes.string,
      isIsnCredentialsPresent: PropTypes.bool,
      isnConnectionTesting: PropTypes.bool,
      isnConnectionTestResult: PropTypes.object,
      onFieldChange: PropTypes.func,
      onIsnConnectionTest: PropTypes.func,
    }
  }

  checkIsnConnectionResult() {
    const { isnConnectionTestResult } = this.props;
    return isnConnectionTestResult && isnConnectionTestResult.status === ISN_RESPONSE_STATUS.OK
  }

  render() {
    const {
      isnKey,
      isnDomain,
      accessKey,
      secretKey,
      isIsnCredentialsPresent,
      isnConnectionTesting,
      isnConnectionTestResult,
      onFieldChange,
      onIsnConnectionTest,
    } = this.props;
    const KEYS_PLACEHOLDER = '********';

    const sideContent = (
      <div className={styles.body}>
        <div className={styles.header}>ISN Login</div>
        <div className={styles.label}>ISN Company Key<div className={styles.value}>{isnKey}</div></div>
        <div className={styles.label}>ISN Domain<div className={styles.value}>{isnDomain}</div></div>
      </div>
      );

    const checkIsnConnectionResult = this.checkIsnConnectionResult();

    return (
      <IsnIntegration className={styles.isnData} sideContent={sideContent}>
        <div className={styles.keys}>
          <Col md={6} className='mb-3'>
            <LabeledInput
              editMode={true}
              label='ISN Access Key'
              value={accessKey}
              maxLength={50}
              placeholder={isIsnCredentialsPresent ? KEYS_PLACEHOLDER : ''}
              onChange={value => onFieldChange('accessKey', value)}
            />
          </Col>
          <Col md={6} className='mb-3'>
            <LabeledInput
              editMode={true}
              label='ISN Secret Access Key'
              value={secretKey}
              maxLength={50}
              placeholder={isIsnCredentialsPresent ? KEYS_PLACEHOLDER : ''}
              onChange={value => onFieldChange('secretKey', value)}
            />
          </Col>
        </div>
        <Col md={12} className='mb-3'>
          <div className={styles.connectionTest}>
            <Button
              key='save'
              kind='green'
              disabled={isnConnectionTesting}
              onClick={onIsnConnectionTest}>
              {isnConnectionTesting ?
                <i className='fa fa-spin fa-spinner' /> :
                'Test Connection'
              }
            </Button>
            <If condition={isnConnectionTestResult}>
              <div className={ checkIsnConnectionResult ? styles.ok : styles.fail }>{isnConnectionTestResult.message} </div>
            </If>
          </div>
        </Col>
      </IsnIntegration>
    );
  }
}

export default IsnIntegrationParams;


// WEBPACK FOOTER //
// src/components/profile/IsnIntegrationParams/index.jsx